import React, { CSSProperties } from 'react'
import CircleLoader from '../CircleLoader'

interface ITokenLoaderProps {
  [key: string]: any
  children: React.ReactElement
  size: number
  style?: CSSProperties
  className?: string
  isLoading: boolean
}

const TokenLoader = (props: ITokenLoaderProps) => {
  const { isLoading, children, ...otherProps } = props
  if (isLoading) {
    return (
      <CircleLoader {...otherProps}>
        {React.cloneElement(children, { className: 'token-loader--loading' })}
      </CircleLoader>
    )
  }
  const { size } = otherProps
  return React.cloneElement(children, { style: { height: size + 'px', width: size + 'px' } })
}

TokenLoader.defaultProps = {
  className: '',
}

export default React.memo(TokenLoader)
